import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router";

import { AuthLayout } from "@/components/layout";
import { Alert, Button, ErrorAlert, Field, Form, Input } from "@/components/ui";
import { auth } from "@/lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const forgot = useMutation({ mutationFn: () => auth.forgotPassword(email.trim()) });
  return (
    <AuthLayout title="Reset your password" subtitle="We'll e-mail you a link to choose a new one.">
      {forgot.isSuccess ? (
        <Alert tone="success">
          If an account exists for {email}, a reset link is on its way. It expires in one hour.
        </Alert>
      ) : (
        <Form
          className="space-y-4"
          error={forgot.error}
          onSubmit={(e) => {
            e.preventDefault();
            forgot.mutate();
          }}
        >
          <ErrorAlert error={forgot.error} />
          <Field label="E-mail" name="email" required>
            {(p) => (
              <Input
                {...p}
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                // eslint-disable-next-line jsx-a11y/no-autofocus -- the form is this screen's only task, so focus starts in its first field (PHP-3348)
                autoFocus
              />
            )}
          </Field>
          <Button type="submit" className="w-full" loading={forgot.isPending}>
            Send reset link
          </Button>
        </Form>
      )}
      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="text-brand-700 hover:underline dark:text-brand-500">
          Back to sign in
        </Link>
      </p>
    </AuthLayout>
  );
}
